import type { SVGProps } from "react";
export interface WheelchairIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WheelchairIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WheelchairIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 15.5a7.62 7.62 0 0 1 3.743-6.564 1.125 1.125 0 0 1 1.147 1.936 5.375 5.375 0 1 0 7.056 7.825l.073-.089a1.125 1.125 0 0 1 1.734 1.43l-.27.343A7.625 7.625 0 0 1 1.875 15.5"
      />
      <path
        fill={color}
        d="M9.526 5.894a1.125 1.125 0 0 1 1.282.792l.027.113.196 1.076H15l.114.006a1.126 1.126 0 0 1 0 2.239l-.114.006h-3.56l.369 2.031a.875.875 0 0 0 .86.718h2.595c1.184 0 2.266.669 2.795 1.727l2.01 4.021.576-.19a1.125 1.125 0 0 1 .711 2.134l-.678.226a2.125 2.125 0 0 1-2.477-.894l-.095-.172-2.06-4.119a.88.88 0 0 0-.782-.483H12.67a3.125 3.125 0 0 1-3.074-2.566l-.974-5.357-.016-.115a1.126 1.126 0 0 1 .921-1.193ZM8.75 2.129a.62.62 0 0 0-.125.37l.012.126a.6.6 0 0 0 .113.245zm1 .741a.6.6 0 0 0 .112-.245l.013-.125-.013-.126a.6.6 0 0 0-.112-.245zm1.126-.37a1.625 1.625 0 0 1-3.242.167L7.625 2.5l.009-.166A1.625 1.625 0 0 1 9.25.875l.166.009c.82.083 1.46.775 1.46 1.616"
      />
    </svg>
  );
}
